import StyledActionText from '@/atoms/ActionText/styles';
import Accordion from '@/molecules/Accordion/Accordion';
import {StyledAccordionBody} from '@/molecules/Accordion/styles';
import breakpoints from '@/theme/constants/breakpoints';
import colors from '@/theme/constants/colors';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import styled from 'styled-components';

export const StyledTitle = styled.p`
  ${typography.Subtitle1}
  margin-bottom: ${sizePx(10)};
`;

export const StyledAwardYear = styled.p`
  ${typography.Body1}
  color: ${colors.darkBlue25};
  margin: ${sizePx(10)} 0 ${sizePx(3)};
`;

export const StyledAwardTitle = styled.p`
  ${typography.Subtitle1}
  margin: ${sizePx(3)} 0;
`;

export const StyledAwardDescription = styled.p`
  ${typography.Body1}
  margin: ${sizePx(3)} 0;
`;

export const StyledBody = styled.div`
  ${StyledActionText} {
    display: block;
    margin: ${sizePx(10)} 0 0;
  }

  > ${StyledAwardYear}:first-child {
    margin: ${sizePx(3)} 0;
  }
`;

export const StyledAccordion = styled(Accordion)`
  ${StyledAccordionBody} > ${StyledAwardYear}:first-child {
    margin: 0 0 ${sizePx(3)};
  }

  ${StyledActionText} {
    display: block;
    margin: ${sizePx(10)} 0 0;
  }

  @media only screen and ${breakpoints.device.m} {
    display: none;
  }
`;

export const StyledAboutAwards = styled.div`
  display: none;

  @media only screen and ${breakpoints.device.m} {
    display: block;
  }
`;
